import { render, staticRenderFns } from "./page-header.vue?vue&type=template&id=7456fbea&"
import script from "./page-header.js?vue&type=script&lang=js&"
export * from "./page-header.js?vue&type=script&lang=js&"
import style0 from "./page-header.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports